/* unplugin-vue-components disabled */import i18n from '@/lang';
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.function.name.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.function.name.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import PopupPicker from "vux/src/components/popup-picker/index.vue"; // this line is trasformed by vux-loader
export default {
  name: 'SinglePicker',
  components: {
    PopupPicker: PopupPicker
  },
  props: {
    value: {
      require: true
    },
    title: String,
    data: Array,
    columns: {
      type: Number,
      default: 1
    },
    format: {
      type: Function,
      default: function _default(v) {
        return {
          name: v.name,
          value: String(v.id)
        };
      }
    },
    placeholder: {
      type: String,
      default: i18n.tc("237")
    },
    show: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    copyValue: {
      get: function get() {
        return this.value ? [String(this.value)] : [];
      },
      set: function set(v) {
        this.$emit('input', v[0]);
      }
    }
  }
};